export default "__VITE_ASSET__BAaKTB2D__"